<div
  lingUnsafeLinksHandler
  *ngIf="(initialized$ | async) === true; else loading"
  class="main-wrapper"
  [class.main-wrapper_with-pending-tag-id]="pendingTagId$ | async"
>
  <ling-header *ngIf="globalWrapperService.wrapped | async"
               [isPreviewPage]="isPreviewPage"
  ></ling-header>
  <div
    class="content-root"
    [class.content-root_free]="(globalWrapperService.wrapped | async) === false"
    [class.content-root_background-white]="isPreviewPage"
  >
    <router-outlet></router-outlet>
  </div>
  <ling-footer *ngIf="globalWrapperService.wrapped | async"></ling-footer>
  <ng-container *ngIf="globalWrapperService.wrapped | async">
    <ling-pending-tag-bar
      [@slideInUpOnEnter]="true"
      [@slideOutDownOnLeave]="true"
      *ngIf="pendingTagId$ | async as pendingTagId"
      [pendingTagId]="pendingTagId"
      (discard)="onDiscardPendingTagId()"
    ></ling-pending-tag-bar>
  </ng-container>
</div>
<ng-template #loading>
  <div
    class="initial-loading-container"
    [class.initial-loading-container_before-switch]="readyToShow"
  >
    <div class="initial-loading">
      <img hidden src="assets/img/logo-text.svg" alt="logo" />
      <img
        src="assets/img/logo.svg"
        alt="Lingon"
        class="initial-loading__logo"
      />
      <mat-progress-spinner
        mode="determinate"
        value="{{ feathers.initializeLoadingProgress | async }}"
        diameter="200"
      ></mat-progress-spinner>
    </div>
  </div>
</ng-template>
<ling-tour-button></ling-tour-button>
